/* --------------------------- APP PATHS ---------------------------- */
export const INSPECTIONS_PATH = '/inspections';
export const ABOUT_PATH = '/about';
export const SETTING_PATH = '/settings';
export const INSPECT_PATH = '/inspect';
export const INSPECTION_CONFIGURATION_PATH = '/inspection-configuration';
export const WORK_PROGRESS_PATH = '/work-progress';
// export const MULTI_LAYERED_PATH = '/multi-layered';
export const WORK_ORDERS_PATH = '/work-orders';
export const ANALYZED_WORK_ORDERS_PATH = '/work-orders/analyzed';
export const WAITING_WORK_ORDERS_PATH = '/work-orders/waiting';
export const WORK_ORDERS_CONFIGURATION_PATH = '/work-order-configuration';

export const DECIMAL_PRECISION = 4;
export const STATEICON_SIZE = 39;
export const LIST_BUTTON_SIZE = 39;
export const INSPECTION_STATUS_PROCESSING = 'PROCESSING';
export const INSPECTION_STATUS_READY = 'READY';

/* --------------------------- WORK PROGRESS POLLING ---------------------------- */
// Cadence for the background poll of /work-order/current. Every fetch reschedules
// the next tick, so user actions (Refresh) reset the countdown for free.
export const WORK_PROGRESS_POLL_INTERVAL_MS = 5000;
// Rows per page for the paginated inspection lists on /work-progress and
// /work-orders/analyzed/:id. The default and the offered choices live together so
// they cannot drift apart — the default must always be one of the options, or the
// select renders blank until the operator picks something.
export const INSPECTION_LIST_DEFAULT_PAGE_SIZE = 100;
export const INSPECTION_LIST_PAGE_SIZE_OPTIONS = [25, 50, 100, 250, 500];
// How stale the data must be before the "Last updated ... ago" label is shown.
// Under healthy polling it never appears; it surfaces only when the backend goes
// quiet or the machine drops offline.
export const WORK_PROGRESS_STALE_AFTER_MS = 30000;
// Used when cellConfigs[0].inspections_warning_banner is absent.
export const SPLIT_DEFAULT_WARNING_CONFIG = {
  trigger_state: 'fail',
  latest_sequence: 3
} as const;

// api error codes
export const NOT_FOUND_ERROR_CODE = 'NOT_FOUND';
export const CONFLICT_ERROR_CODE = 'CONFLICT';
export const FORBIDDEN_ERROR_CODE = 'FORBIDDEN';
export const VALIDATON_ERROR_CODE = 'VALIDATION';
